<template>
  <div class="mobile-wallet-card">
    <div
      id="m-deposit"
      :class="!isBuyCrypto ? 'wallet-list-on' : 'wallet-list'"
      @click="$emit('update:is-buy-crypto', false)"
    >
      {{ $t('Bao.deposit') }}
    </div>
    <div
      id="m-crypto-buy"
      :class="isBuyCrypto ? 'wallet-list-on' : 'wallet-list'"
      @click="$emit('update:is-buy-crypto', true)"
    >
      {{ $t('Bao.buy_cryptocurrency') }}
    </div>
    <div
      id="m-withdraw"
      class="wallet-list"
      @click="$router.push('/withdrawal')"
    >
      {{ $t('Bao.withdraw_menu') }}
    </div>
    <div
      id="m-crypto-exchange"
      class="wallet-list"
      @click="$router.push('/withdrawal?mode=crypto-exchange')"
    >
      {{ $t('Bao.crypto_exchange') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositTabNav',
  props: {
    isBuyCrypto: {
      type: Boolean,
      default: false
    }
  }
}
</script>
